import { render } from "./VerifySlide.vue?vue&type=template&id=813b88d6&scoped=true"
import script from "./VerifySlide.vue?vue&type=script&lang=js"
export * from "./VerifySlide.vue?vue&type=script&lang=js"

import "./VerifySlide.vue?vue&type=style&index=0&id=813b88d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813b88d6"]])

export default __exports__